export default "__VITE_ASSET__0360aedb__"